import React from 'react';
import { CTAButton } from './CTAButton';
export function Benefits() {
  const benefits = [{
    emoji: '⏰',
    title: 'Vas a tener actividades listas en menos de 5 minutos',
    desc: 'Abrís el kit, imprimís y jugás.'
  }, {
    emoji: '📵',
    title: 'Siempre vas a tener una alternativa real a las pantallas',
    desc: 'Actividades prácticas para el día a día.'
  }, {
    emoji: '🧠',
    title: 'Vas a estimular lenguaje, creatividad y movimiento',
    desc: 'Con juegos diseñados para acompañar el desarrollo real.'
  }, {
    emoji: '💛',
    title: 'Vas a compartir momentos de calidad sin estrés',
    desc: 'Sin presionar ni sobreestimular.'
  }, {
    emoji: '💰',
    title: 'Vas a ahorrar dinero en juguetes que duran poco',
    desc: 'Incluye actividades reutilizables.'
  }, {
    emoji: '🏡',
    title: 'Vas a poder acompañar el desarrollo desde casa',
    desc: 'Sin necesidad de materiales caros.'
  }];
  return <section className="bg-white py-16 px-4 sm:px-6" data-id="element-27">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-28">
        <div className="text-center space-y-4" data-id="element-29">
          <span className="text-5xl block mb-4" data-id="element-30">🌟</span>
          <h2 className="font-archivo text-3xl sm:text-4xl md:text-5xl uppercase text-brand-black" data-id="element-31">
            Lo que vas a lograr con este kit
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-32">
          {benefits.map((benefit, idx) => <div key={idx} className="bg-gray-50 p-6 rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-33">
              <div className="text-4xl mb-4" data-id="element-34">{benefit.emoji}</div>
              <h3 className="font-bold text-xl text-brand-black mb-2 leading-tight" data-id="element-35">
                {benefit.title}
              </h3>
              <p className="text-gray-600 font-medium" data-id="element-36">{benefit.desc}</p>
            </div>)}
        </div>

        <div className="pt-8" data-id="element-37">
          <CTAButton text="🌱 QUIERO EL KIT COMPLETO" color="green" data-id="element-38" />
        </div>
      </div>
    </section>;
}